import { SyllabaryKatakanaIcon } from './SyllabaryKatakanaIcon';

/**
 * author: Haley Halcyon
 * id 220577A0-1D92-46EA-8116-DF964F6C57F0
 * name syllabary-katakana
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/syllabary-katakana.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemKatakanaIcon = SyllabaryKatakanaIcon;
export default WritingSystemKatakanaIcon